// Suggestions only: the normal reading form still requires explicit confirmation.
export function suggestVoiceReading(transcript, params, selected) {
  const aliases = {
    alk: 'alkalinity|alk',
    calcium: 'calcium',
    magnesium: 'magnesium',
    nitrate: 'nitrate',
    phosphate: 'phosphate',
    salinity: 'salinity',
    temp: 'temperature',
    ph: 'ph',
  };
  const named = params.filter((p) =>
    new RegExp(
      `\\b(${aliases[p.key] || String(p.label || p.key).replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})\\b`,
      'i'
    ).test(transcript)
  );
  if (named.length > 1) return null;
  const param = named[0]?.key || selected;
  const cfg = params.find((p) => p.key === param);
  if (!cfg) return null;
  let normalized = transcript.toLowerCase();
  const digits = {
    zero: '0',
    one: '1',
    two: '2',
    three: '3',
    four: '4',
    five: '5',
    six: '6',
    seven: '7',
    eight: '8',
    nine: '9',
  };
  const word = '(?:zero|one|two|three|four|five|six|seven|eight|nine)';
  // Every digit after "point": "zero point zero three" is 0.03, not 0.0.
  normalized = normalized.replace(
    new RegExp(`\\b(${word})\\s+point((?:\\s+${word})+)\\b`, 'g'),
    (_, a, rest) =>
      `${digits[a]}.${rest
        .trim()
        .split(/\s+/)
        .map((w) => digits[w])
        .join('')}`
  );
  // A digit word left over ("8.4 and five") could belong to the number.
  if (new RegExp(`\\b${word}\\b`).test(normalized)) return null;
  // Do not interpret a second reading, a dosing amount, or an unstated conversion.
  if (
    /\b(ml|millilit|dose|dosed|celsius|fahrenheit|sg|specific gravity|ppb|meq)\b/i.test(normalized)
  )
    return null;
  if (
    /\b(twenty|thirty|forty|fifty|sixty|seventy|eighty|ninety|hundred|thousand)\b/i.test(normalized)
  )
    return null;
  const numbers = normalized.match(/-?\d+(?:\.\d+)?/g);
  if (numbers?.length !== 1) return null;
  return { param, value: numbers[0] };
}

export function localFuture(days, now = Date.now()) {
  const d = new Date(now + days * 86400000);
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
}
